import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Source your product",
    body: "Wholesale peptide supply lined up for your brand and your margins.",
  },
  {
    num: "02",
    title: "Make it yours",
    body: "White-label vials, brand identity, and a custom website shaped around you.",
  },
  {
    num: "03",
    title: "Launch & ship",
    body: "Checklist, final review, and 3PL fulfillment carrying every order out.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="scroll-mt-24 py-20 sm:py-28" tabIndex={-1}>
    <div className="mx-auto w-full max-w-shell px-5 sm:px-8">
      <Reveal>
        <Eyebrow index="03" testId="process-eyebrow">
          How it works
        </Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-paper sm:text-4xl">
          From first idea to next step.
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-10 sm:grid-cols-3 sm:gap-0">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.1}>
            <div
              data-testid={`process-step-${i + 1}`}
              className={`sm:px-9 ${i > 0 ? "sm:border-l sm:border-white/[0.08]" : "sm:!pl-0"}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lilac font-display text-sm font-extrabold text-ink">
                {step.num}
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold text-paper">{step.title}</h3>
              <p className="mt-2.5 max-w-xs text-sm leading-relaxed text-paper/60">{step.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
